/**
 * Layout route for /companies/$companyId/* — exists only so TanStack Router's
 * file-based dot-notation has a parent for the sibling files
 * ($companyId.facturas.*, $companyId.terceros.*, …). Renders the matched
 * child via <Outlet />; the actual company detail page lives in
 * $companyId.index.tsx and renders at /companies/$companyId/.
 *
 * Without this file, the generator references an undefined parent route and
 * the children fail to render — every sub-link falls through to the root.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/companies/$companyId")({
  component: CompanyLayout,
});

function CompanyLayout() {
  return <Outlet />;
}
